/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {Languages} from './Languages'
import {toAbsoluteUrl} from '../../../helpers'
import { usePermissions } from '../../../../app/modules/auth/hooks/usePermissions'
import Cookies from 'js-cookie'

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth();
  const { hasPermission } = usePermissions();
  const isSuperAdmin = hasPermission('SUPER_ADMINISTRADOR');
  const canAccessCursos = hasPermission('CURSO') || hasPermission('GESTAO_CURSO') || hasPermission('PROFESSOR');
  const canAccessAssociados = hasPermission('ADMINISTRATIVO');
  const canAccessTratamentos = hasPermission('GESTAO_TRATAMENTO') || hasPermission('ATENDENTE') || hasPermission('TRATAMENTO');
  const canAccessDebitos = hasPermission('GESTAO_DEBITO') || hasPermission('DEBITO') || hasPermission('ADMINISTRATIVO');
  const [selectedModule, setSelectedModule] = useState<string>('');

  // Get selectedModule from sessionStorage
  useEffect(() => {
    const module = sessionStorage.getItem('selectedModule');
    if (module) {
      setSelectedModule(module);
    }

    // Listen for changes in sessionStorage
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'selectedModule') {
        setSelectedModule(e.newValue || '');
      }
    }

    // Listen for custom events (when sessionStorage is changed from same tab)
    const handleCustomStorageChange = () => {
      const module = sessionStorage.getItem('selectedModule');
      setSelectedModule(module || '');
    }

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('selectedModuleChanged', handleCustomStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('selectedModuleChanged', handleCustomStorageChange);
    };
  }, []);

  const handleSelectedModule = (module) => {
    // Update sessionStorage
    sessionStorage.setItem('selectedModule', module);
    
    // Update cookie for current user
    if (currentUser?.idUsuario) {
      const cookieKey = `selectedModule_user${currentUser.idUsuario}`;
      Cookies.set(cookieKey, module, { expires: 7 }); // Expires in 7 days
    }
    
    // Dispatch event to notify other components
    window.dispatchEvent(new CustomEvent('selectedModuleChanged'));
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='nav-select-modules'>
        {
          (canAccessCursos || canAccessTratamentos || isSuperAdmin) && 
          <div 
            className={`nav-select-modules-item ${selectedModule === 'cursos' ? 'selected' : ''}`} 
            onClick={() => handleSelectedModule('cursos')}
          >
            <img src={toAbsoluteUrl('/media/assemp/icon-module-courses.svg')} alt=''/>
            <div>
              <p className='nav-select-modules-text'>Cursos e tratamentos</p>
              {selectedModule === 'cursos' && <strong>Selecionado</strong>}
            </div>
          </div>
        }

        {
          (canAccessDebitos || isSuperAdmin) &&
          <div 
            className={`nav-select-modules-item ${selectedModule === 'financeiro' ? 'selected' : ''}`} 
            onClick={() => handleSelectedModule('financeiro')}
          >
            <img src={toAbsoluteUrl('/media/assemp/icon-module-financial.svg')} alt=''/>
            <div>
              <p className='nav-select-modules-text'>Financeiro</p>
              {selectedModule === 'financeiro' && <strong>Selecionado</strong>}
            </div>
          </div>
        }
        {
          (isSuperAdmin) &&
          <div 
            className={`nav-select-modules-item ${selectedModule === 'juridico' ? 'selected' : ''}`} 
            onClick={() => handleSelectedModule('juridico')}
          >
            <img src={toAbsoluteUrl('/media/assemp/icon-module-legal.svg')} alt=''/>
            <div>
              <p className='nav-select-modules-text'>Jurídico</p>
              {selectedModule === 'juridico' && <strong>Selecionado</strong>}
            </div>
          </div>
        }
      </div>

      {/* <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl('/media/avatars/300-3.jpg')} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.first_name} {currentUser?.first_name}
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {currentUser?.email}
            </a>
          </div>
        </div>
      </div> */}

      <hr className='my-4'/>

      <div className='menu-item px-5'>
        <Link to={'/profile/update-password'} className='menu-link px-5 justify-content-center'>
          Atualizar senha
        </Link>
      </div>

      {/* <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          <span className='menu-text'>My Projects</span>
          <span className='menu-badge'>
            <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>
          </span>
        </a>
      </div>

      <div
        className='menu-item px-5'
        data-kt-menu-trigger='hover'
        data-kt-menu-placement='left-start'
        data-kt-menu-flip='bottom'
      >
        <a href='#' className='menu-link px-5'>
          <span className='menu-title'>My Subscription</span>
          <span className='menu-arrow'></span>
        </a>

        <div className='menu-sub menu-sub-dropdown w-175px py-4'>
          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Referrals
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Billing
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Payments
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link d-flex flex-stack px-5'>
              Statements
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='View your statements'
              ></i>
            </a>
          </div>

          <div className='separator my-2'></div>

          <div className='menu-item px-3'>
            <div className='menu-content px-3'>
              <label className='form-check form-switch form-check-custom form-check-solid'>
                <input
                  className='form-check-input w-30px h-20px'
                  type='checkbox'
                  value='1'
                  defaultChecked={true}
                  name='notifications'
                />
                <span className='form-check-label text-muted fs-7'>Notifications</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          My Statements
        </a>
      </div>

      <div className='separator my-2'></div>

      <Languages />

      <div className='menu-item px-5 my-1'>
        <Link to='/crafted/account/settings' className='menu-link px-5'>
          Account Settings
        </Link>
      </div> */}

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5 justify-content-center'>
          Sair  
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
